import { AxiosInstance, isAxiosError } from "axios";
import z from "zod";
import { StatusInventarioArquivo } from "./status-inventario-arquivo";
import { TipoInventarioArquivo } from "./tipo-inventario-arquivo";
import { InventarioArquivo } from "./inventario-arquivo";
import { InventarioArquivoSchema } from "./inventario-arquivo-schema";

const SearchRequestSchema = z.object({
    inventario_id: z.string().optional(),
    arquivo_id: z.string().optional(),
    status: z.enum(StatusInventarioArquivo).optional(),
    tipo: z.enum(TipoInventarioArquivo).optional()
})

type SearchRequest = z.infer<typeof SearchRequestSchema>




export class InventarioArquivoRepository {
    constructor(
        private api: AxiosInstance
    ) { }

    async searchOne(query: SearchRequest): Promise<InventarioArquivo> {
        try {
            const params = SearchRequestSchema.parse(query)
            const { data } = await this.api.get<InventarioArquivo[]>(`inventario-arquivos/search-one`, {
                params
            })

            return InventarioArquivoSchema.parse(data)
        } catch (error) {
            if (isAxiosError(error)) {
                throw new Error(error.response.data?.error || 'Não foi possível buscar os registros')
            }
            throw error
        }
    }

    async search(query: SearchRequest): Promise<InventarioArquivo[]> {
        try {
            const params = SearchRequestSchema.parse(query)
            const { data } = await this.api.get<InventarioArquivo[]>(`inventario-arquivos/search`, {
                params
            })

            return z.array(InventarioArquivoSchema).parse(data)
        } catch (error) {
            if (isAxiosError(error)) {
                throw new Error(error.response.data?.error || 'Não foi possível buscar os registros')
            }
            throw error
        }
    }

    async upload(inventario_id: string, tipo: TipoInventarioArquivo, arquivo: File) {
        try {
            const body = new FormData()
            body.set('inventario_id', inventario_id)
            body.set('tipo', tipo)
            body.append('arquivo', arquivo)

            const { data } = await this.api.post<InventarioArquivo>(`inventario-arquivos/upload`, body)

            return InventarioArquivoSchema.parse(data)
        } catch (error) {
            if (isAxiosError(error)) {
                throw new Error(error.response.data?.error || 'Não foi possível enviar o arquivo')
            }
            throw error
        }
    }
}